import styles from '../Shop.module.css';
import { Pagination } from 'react-bootstrap';

const noop = () => {};

export default function ShopPagination({ currentPage = 1, totalPages = 1, onPageChange = noop } = {}) {
    if (totalPages < 2) {
        return null;
    }

    const items = [];
    let startPage = 1;
    let endPage = totalPages;

    if (totalPages > 7) {
        startPage = currentPage - 3;
        endPage = currentPage + 3;
        if (startPage < 1) {
            endPage += Math.abs(startPage) + 1;
            startPage = 1;
        } else if (endPage > totalPages) {
            startPage -= endPage - totalPages;
            endPage = totalPages;
        }
    }

    if (startPage > 1) {
        items.push(
            <Pagination.First
                key={'first'}
                onClick={(e) => { e.target.blur(); onPageChange(1); }}
                className={styles.pageItem}
            />
        );
    }

    for (let number = startPage; number <= endPage; number++) {
        items.push(
            <Pagination.Item
                key={number}
                active={number === currentPage}
                onClick={(e) => { e.target.blur(); onPageChange(number); }}
                className={styles.pageItem}
            >{number}</Pagination.Item>
        );
    }

    if (endPage < totalPages) {
        items.push(
            <Pagination.Last
                key={'last'}
                onClick={(e) => { e.target.blur(); onPageChange(totalPages); }}
                className={styles.pageItem}
            />
        );
    }

    // items.push(
    //     <Col className="mx-2" xs="auto" key={'input'}>
    //         <Form.Control defaultValue="1" type="number" min={1} max={totalPages} htmlSize={2} onChange={(e) => {
    //             onPageChange(Number(e.target.value));
    //         }} />
    //     </Col>
    // );

    return (
        <div>
            <Pagination className="justify-content-center mb-3" size="sm">{items}</Pagination>
        </div>
    );
}